import React from 'react';
import { connect } from 'react-redux';
import { injectIntl } from 'react-intl';
import svodMessages from '../../locales/svod';
import PauseImg from '../../assets/svod/player-controls/pause.svg';
import PlayImg from '../../assets/svod/player-controls/play.svg';
import expandImg from '../../assets/svod/appletv-icons/expand.svg';
import minimizeImg from '../../assets/svod/appletv-icons/minimize.svg';
import captions from "../../assets/svod/appletv-icons/captions.svg";
import audio_track from "../../assets/svod/appletv-icons/audio-track.svg";
import { EnvType } from "./constants";
import dolby_atmos_flat from "../../assets/svod/appletv-icons/dolby-atmos-flat.svg";
import check_mark from "../../assets/svod/appletv-icons/check-mark.svg";

const seekBarPadding = .04; // based on the padding set in the CSS file
const appleTimestampWidth = 7; // based on the padding and width of timestamps

class PlayerControls extends React.Component {
	constructor(props) {
		super(props);

		this.state = {
			scrubBarPosition: 0,
			isSeeking: false,
			newLocationInSeconds: 0,
			hoverTimestampInSeconds: 0,
			progressPercentageString: "",
			hoverProgressPercentageString: "",
			currentLocationString: "0:00 ",
			thumbnailURL: "",
			hidePlayerControls: true,
			openPopUp: "",

			// TO-DO: Get the list options from environment or video object
			captions: {
				title: this.props.intl.formatMessage(svodMessages.subtitles_upper),
				selected: "Off",
				options: [
					"Off",
				],
			},
			audioTrack: {
				title: this.props.intl.formatMessage(svodMessages.audio_track_upper),
				selected: "English",
				options: [
					"English",
					"English AD"
				]
			},
		};
		
		this.dragLocation = this.dragLocation.bind(this);
		this.hoverTimestampLocation = this.hoverTimestampLocation.bind(this);
		this.getTimeLocationStr = this.getTimeLocationStr.bind(this);
		this.toggleSkipButtonDisplay = this.toggleSkipButtonDisplay.bind(this);
		this.clickSeek = this.clickSeek.bind(this);
		this.findVolumeLevel = this.findVolumeLevel.bind(this);
		this.toggleCaptionsSelection = this.toggleCaptionsSelection.bind(this);
		this.toggleAudioTrackSelection = this.toggleAudioTrackSelection.bind(this);
	}

	findVolumeLevel() {
		let volumeInput = document.getElementById("volume-input");
		let newVolume = (volumeInput.value / 100);
		this.props.updateVolume(newVolume);
	}

	componentDidUpdate(prevProps, prevState) {
		const {
			promoAsset,
			mainAsset,
			isAdPlayback,
			environment
		} = this.props;

		const {
			newLocationInSeconds,
			isSeeking,
			hidePlayerControls
		} = this.state;

		let activeVideo = this.props.video;
		if (environment === EnvType.APPLETV) {
			activeVideo = isAdPlayback ? promoAsset : mainAsset;
		}

		if (!activeVideo) return <span className="empty-player-controls"></span>;

		if (hidePlayerControls && prevProps.currentStoredTime !== this.props.currentStoredTime) {
			this.setState({ hidePlayerControls: false });
		}

		if (isSeeking && !prevState.isSeeking) {
			this.props.pause();
		} else if (!isSeeking && prevState.isSeeking) {
			this.props.seek(newLocationInSeconds);
		}

		if (prevProps.currentStoredTime !== this.props.currentStoredTime) {
			let currentLocationString = this.getTimeLocationStr(this.props.currentStoredTime);			
			let progressPercentageString = `calc(${Math.floor((this.props.currentStoredTime / activeVideo.video.duration) * 100)}% - 9px)`;			
			if (environment === EnvType.APPLETV) {
				progressPercentageString = `calc(${Math.floor((this.props.currentStoredTime / activeVideo.video.duration) * 100)}%)`;
			}
			if (this.props.isAdPlayback) {
				if (this.props.currentStoredTime < 1 && this.props.pauseAdAnimation) {
					this.props.pauseAdAnimation();
				} else if (this.props.isPlaying && this.props.playAdAnimation) {
					this.props.playAdAnimation();
				}
				this.toggleSkipButtonDisplay(this.props.currentStoredTime);
			}

			this.setState({ progressPercentageString, currentLocationString });
		}

		if (prevState.newLocationInSeconds !== newLocationInSeconds) {
			let currentLocationString = this.getTimeLocationStr(newLocationInSeconds);
			let progressPercentageString = `${(newLocationInSeconds / activeVideo.video.duration) * 100}%`;			

			this.setState({ progressPercentageString, currentLocationString });
		}
	}

	clickSeek(e) {
		const {
			environment,
			promoAsset,
			mainAsset,
			currentPlaybackStage,
			isAdPlayback,
			currentStoredTime,
			isTargetAsset
		} = this.props;
	
		let activeVideo = this.props.video;
		if (environment === EnvType.APPLETV) {
			activeVideo = isAdPlayback ? promoAsset : mainAsset;
		}

		let paddingAccountForScrolling = window.innerWidth;
		if (this.props.environment === EnvType.PEACOCK) {
			paddingAccountForScrolling = window.innerWidth * seekBarPadding; 
		} else if (this.props.environment === EnvType.APPLETV) {
			paddingAccountForScrolling = window.innerWidth * seekBarPadding - appleTimestampWidth; 
		}
		let x = e.clientX - paddingAccountForScrolling;
		let seekBar = document.getElementById("seek-bar");
		let totalWidth = seekBar.offsetWidth;
		let newLocationDecimal = x / totalWidth;
		if (newLocationDecimal < 0) newLocationDecimal = 0;
		let newLocationInSeconds =  activeVideo ? activeVideo.video.duration * newLocationDecimal : 0;

		if (
			((!this.props.isAdPlayback || 
			(this.props.skipButtonInfo && this.props.skipButtonInfo.target_promo_seek_enabled)) &&
			this.props.environment !== EnvType.APPLETV
			) || 
			(this.props.environment === EnvType.APPLETV &&
			((isTargetAsset && this.props.skipButtonInfo && this.props.skipButtonInfo.target_promo_seek_enabled) ||
			(!isTargetAsset)))
		) {
			this.props.eventHandler({ 
				data: { 
					event_type: "player_activity", 
					type: "successful_seek", 
					asset_name: mainAsset ? mainAsset.name : "", 
					asset_id: mainAsset ? mainAsset._id : "",
					promo_id: promoAsset ? promoAsset._id : "",
					page_location: "watch_page",
					timecode: currentStoredTime, // time since video started
					current_playback_stage: isAdPlayback ? currentPlaybackStage : "main_content",
					new_time: newLocationInSeconds,
					time: Date.now()
				} 
			});
			this.props.seek(newLocationInSeconds);
			this.setState({ newLocationInSeconds });
		} else {
			this.props.eventHandler({ 
				data: { 
					event_type: "player_activity", 
					type: "attempted_seek", 
					asset_name: mainAsset ? mainAsset.name : "", 
					asset_id: mainAsset ? mainAsset._id : "",
					promo_id: promoAsset ? promoAsset._id : "",
					page_location: "watch_page",
					timecode: currentStoredTime, // time since video started
					current_playback_stage: isAdPlayback ? currentPlaybackStage : "main_content",
					attempted_new_time: newLocationInSeconds,
					time: Date.now()
				} 
			});
		}
	}

	getTimeLocationStr(time) {
		let currentTime = Math.floor(time);
		let timeLocationStr;
		if (isNaN(currentTime)) {
			timeLocationStr = "0:00";
		} else {
			let minutes = Math.floor(currentTime/60);
			let seconds = currentTime - minutes * 60;
			if (seconds < 10) seconds = `0${seconds}`;
			timeLocationStr = `${minutes}:${seconds} `;
		}
		return timeLocationStr;
	}

	dragLocation(e) {
		const {
			promoAsset,
			mainAsset,
			isAdPlayback,
			environment,
			currentStoredTime,
			currentPlaybackStage
		} = this.props;

		let activeVideo = this.props.video;
		if (environment === EnvType.APPLETV) {
			activeVideo = isAdPlayback ? promoAsset : mainAsset;
		}

		if (this.state.isSeeking) {
			let paddingAccountForScrolling = window.innerWidth;
			if (this.props.environment === EnvType.PEACOCK) {
				paddingAccountForScrolling = window.innerWidth * seekBarPadding; 
			} else if (this.props.environment === EnvType.APPLETV) {
				paddingAccountForScrolling = window.innerWidth * seekBarPadding - appleTimestampWidth; 
			}
			let x = e.clientX - paddingAccountForScrolling;
			let seekBar = document.getElementById("seek-bar");
			let totalWidth = seekBar.offsetWidth;
			let newLocationDecimal = x / totalWidth;
			if (newLocationDecimal < 0) newLocationDecimal = 0;
			if (newLocationDecimal > 1) newLocationDecimal = 1;
			let newLocationInSeconds =  activeVideo.video.duration * newLocationDecimal;

			this.props.eventHandler({ 
				data: { 
					event_type: "player_activity", 
					type: "drag_seek", 
					asset_name: mainAsset ? mainAsset.name : "", 
					asset_id: mainAsset ? mainAsset._id : "",
					promo_id: promoAsset ? promoAsset._id : "",
					page_location: "watch_page",
					timecode: currentStoredTime, // time since video started
					current_playback_stage: isAdPlayback ? currentPlaybackStage : "main_content",
					new_time: newLocationInSeconds,
					time: Date.now()
				} 
			});
			this.setState({ newLocationInSeconds });
		}
	}

	hoverTimestampLocation(e) {
		if (!this.props.video.video.duration) {
			return;
		}

		let paddingAccountForScrolling = window.innerWidth;
		if (this.props.environment === EnvType.PEACOCK || this.props.environment === EnvType.APPLETV) {
			paddingAccountForScrolling = window.innerWidth * seekBarPadding;
		}
		let x = e.clientX - paddingAccountForScrolling;
		let seekBar = document.getElementById("seek-bar");
		let totalWidth = seekBar.offsetWidth;
		let newLocationDecimal = x / totalWidth;
		if (newLocationDecimal < 0) newLocationDecimal = 0;
		let hoverTimestampInSeconds =  Math.ceil(this.props.video.video.duration * newLocationDecimal);    
		if (hoverTimestampInSeconds < 1) hoverTimestampInSeconds = 1;
		let hoverProgressPercentageString = `${(hoverTimestampInSeconds / this.props.video.video.duration) * 100}%`;

		if ((hoverTimestampInSeconds / this.props.video.video.duration) * 100 > 80) {
			hoverProgressPercentageString = `80%`;
		}

		let videoStrArr = this.props.video.video.thumbnail.split("thumbnail-");
		let zeroString = "00000";
		let timestampLocation = (zeroString+hoverTimestampInSeconds).slice(-zeroString.length);
		let thumbnailURL = videoStrArr[0] + "thumbnail-" + timestampLocation + videoStrArr[1].slice(5);
		let cleanURLArr = thumbnailURL.split("?"); // remove AWS access key to display image

		this.setState({ thumbnailURL: cleanURLArr[0], hoverTimestampInSeconds, hoverProgressPercentageString });		
	}

	toggleSkipButtonDisplay(currentTime) {
		const {
			skipButtonInfo,
			mainAsset,
			promoAsset,
			displaySkipButton
		} = this.props;

		if (skipButtonInfo) {
			if (
				Math.floor(currentTime) > skipButtonInfo.display_button_delay
				&& Math.floor(currentTime) < skipButtonInfo.remove_button_delay
				&& !displaySkipButton
			) {
				this.props.toggleSkipButtonDisplay(true);
			} else if (
				(Math.floor(currentTime) < skipButtonInfo.display_button_delay || Math.floor(currentTime) > skipButtonInfo.remove_button_delay)
				&& displaySkipButton
			) {

				this.props.eventHandler({ 
					data: { 
						event_type: "button_click", 
						type: "skip_not_clicked", 
						asset_name: mainAsset.name, 
						asset_id: mainAsset._id,
						promo_id: promoAsset._id,
						page_location: "watch_page",
						timecode: this.state.currentStoredAdTime, // time since promo started
						time: Date.now()
					} 
				});
	
				this.props.toggleSkipButtonDisplay(false);
			}
		}
	}

	toggleCaptionsSelection() {
		if (this.state.openPopUp == "captions") {
			this.setState({ openPopUp: "" });
		} else {
			this.setState({ openPopUp: "captions" });
		}
	}
	
	toggleAudioTrackSelection() {
		if (this.state.openPopUp == "audioTrack") {
			this.setState({ openPopUp: "" });
		} else {
			this.setState({ openPopUp: "audioTrack" });
		}
	}


	render() {
		const {
			promoAsset,
			mainAsset,
			isPlaying,
			play,
			pause,
			isFullscreen,
			triggerFullscreen,
			currentStoredTime,
			isTester,
			isAdPlayback,
			environment,
			skipButtonInfo,
			isTargetAsset
		} = this.props;

		const {
			progressPercentageString,
			hoverProgressPercentageString,
			currentLocationString,
			thumbnailURL,
			isSeeking
		} = this.state;

		let activeVideo = this.props.video;
		if (environment === EnvType.APPLETV) {
			activeVideo = isAdPlayback ? promoAsset : mainAsset;
		}

		if (!activeVideo) return <span className="empty-player-controls"></span>;

		let season = (activeVideo && activeVideo.season_num) ? (
			<span>
				<p>{this.props.intl.formatMessage(svodMessages.season_initial)}:{activeVideo.season_num}</p>
			</span>
		) : "";

		let episode = (activeVideo && activeVideo.episode_num) ? (
			<span>
				<p>{this.props.intl.formatMessage(svodMessages.episode_initial)}:{activeVideo.episode_num}</p>
			</span>
		) : "";

		let divider = (episode || season) ? (
			<span className="divider-dot">•</span>                    
		) : "";

		let mpaa = (activeVideo && activeVideo.content && activeVideo.content.mpaa) ? (
			<span className="index-rating">{activeVideo.content.mpaa.label}</span>
		) : "";

		let totalDuration = activeVideo && activeVideo.video ? activeVideo.video.duration : 0;
		let totalTimeStr;
		if (isNaN(totalDuration)) {
			totalTimeStr = "0:00";
		} else {
			let totalMinutes = Math.floor(totalDuration/60);
			let remainingSeconds = totalDuration - totalMinutes * 60;
			if (remainingSeconds < 10) {
				remainingSeconds = `0${remainingSeconds}`;
			}
			totalTimeStr = `${totalMinutes}:${remainingSeconds}`;
		}

		let volumeControl = this.props.updateVolume ? (
			<span className="volume-control-container">
				<input className="volume-control" id="volume-input" defaultValue={this.props.volumeLevel} type="range" min="0" max="100" onInput={this.findVolumeLevel} />
			</span>
		) : (
			<span className="volume-control-container"></span>								
		);

		let selectionPopUp = (popUp) => {
			let popUpType = this.state[popUp];
			let options = popUpType.options.map((option, idx) => {
				return (
					<li key={`pop-up-option-${idx}`}>
						{option}
						{popUpType.selected == option && (
							<img src={check_mark} />
						)}
						{/* TO-DO: Remove hardcoding when we have actual options to offer */}
						{option == "English AD" && (
							<span className="tooltip">{this.props.intl.formatMessage(svodMessages.not_available)}</span>
						)}
					</li>
				);
			});

			return (
				<div className="settings-pop-up">
					<div className="header">
						<div className="title">{popUpType.title}</div>
						{popUp == "audioTrack" && activeVideo && activeVideo.content && activeVideo.content.extra_metadata && activeVideo.content.extra_metadata.dolby_atmos && (
							<img src={dolby_atmos_flat} />
						)}
					</div>
					<ul className="options-list">
						{options}
					</ul>
				</div>
			);
		};

		switch(environment) {
			case EnvType.PEACOCK: {

				let adBreakIndicators = this.props.video.promo_insertion_times ? this.props.video.promo_insertion_times.map((adTime, idx) => {
					let percentage = `${Math.floor( adTime / activeVideo.video.duration * 100)}%`;
					return (
						<div className="seek-bar-adBreak" style={{left: `calc(${percentage} + 12px)`}} key={`adBreak-${idx}`}></div>          
					);
				}) : "";

				let timestamp = currentLocationString + ' / ' + totalTimeStr;

				if (isAdPlayback) {
					let durationTime = promoAsset && promoAsset.video ? promoAsset.video.duration : 0;
					let countdown = Math.floor(durationTime - currentStoredTime + 1);
					let adLength = Math.floor(durationTime);

					const countdownCircleAnimation = {
						animation: `countdown ${adLength}s linear infinite forwards`
					};
					return (
						<div className="bottom-section">
							<li className={"pilotly-button pilotly-bar-button pilotly-bar-button-seek"}>

								<div id="countdown">
									<div>{countdown}</div>
									<svg>
										<circle className="background-circle" r="18" cx="20" cy="20" ></circle>
									</svg>
									<svg>
										<circle className="progress-circle" id="progress-circle" r="18" cx="20" cy="20" style={countdownCircleAnimation}></circle>
									</svg>
								</div>
							</li>

							<div className="video-controls peacock-icon" onClick={isPlaying ? pause : play}> 
								<img src={isPlaying ? PauseImg : PlayImg} />
							</div>         
						</div>
					);
				} else {

					return (
						<div className="bottom-section" onMouseMove={e => this.dragLocation(e)} onMouseUp={() => this.setState({isSeeking: false})} onMouseLeave={() => this.setState({isSeeking: false})}>
							<p className="title">{activeVideo.content.title}</p>            
							<div className="metadata">
								{season} 
								{episode} 
								{divider}
								{mpaa}                                        
							</div>

							<li className={"pilotly-button pilotly-bar-button pilotly-bar-button-seek"}>
								<div className="seek-control-container">
									<div className="seek-bar" id="seek-bar"></div>
									<div className="seek-bar-progress" style={{width: progressPercentageString}} ></div>
									<div className={`seek-bar-handle ${activeVideo.target_content && !isTester ? "disabled" : ""}`} onMouseDown={() => this.setState({isSeeking: true})} style={{left: progressPercentageString}}></div>
									{adBreakIndicators}
								</div>          

								<div className="seek-bar-timestamp">
									{timestamp}
								</div>
							</li>

							<div className="video-controls peacock-icon" onClick={isPlaying ? pause : play}> 
								<img src={isPlaying ? PauseImg : PlayImg} />
							</div>
						</div>
					);
				}
			}

			case EnvType.APPLETV: {
				if (isAdPlayback) {

					return (
						<div className={`apple-player-controls ${this.state.hidePlayerControls ? "strict-hidden" : ""}`} onMouseMove={e => this.dragLocation(e)} onMouseUp={() => this.setState({isSeeking: false})} onMouseLeave={() => this.setState({isSeeking: false})}>
	
							<li className={"pilotly-button pilotly-bar-button pilotly-bar-button-seek"}>
								
								<div className="seek-bar-timestamp current-timestamp">
									{currentLocationString}
								</div>
								
								<div className="seek-control-container" onMouseMove={(e) => this.hoverTimestampLocation(e)}>
									<div className="seek-bar" id="seek-bar" onClick={(e) => this.clickSeek(e)}></div>
									<div className="seek-bar-progress" style={{width: progressPercentageString}} ></div>
									<div className={`seek-bar-handle ${(skipButtonInfo && skipButtonInfo.target_promo_seek_enabled) || isTester ? "" : "disabled"}`} onMouseDown={() => this.setState({isSeeking: true})} style={{left: progressPercentageString}}></div>
								</div>          
	
								<div className="seek-bar-timestamp total-timestamp">
									{totalTimeStr}
								</div>
							</li>
	
							<div className="watch-page-buttons">
								{volumeControl}
								<span className="video-controls appletv-player-button" onClick={isPlaying ? pause : play}> 
									<img src={isPlaying ? PauseImg : PlayImg} />
								</span>				
								<span className="fullscreen appletv-player-button" onClick={triggerFullscreen}>
									<img src={isFullscreen ? minimizeImg : expandImg} />
								</span>
							</div>
						</div>
					);
				} else {

					return (
						<div className={`apple-player-controls ${this.state.hidePlayerControls ? "strict-hidden" : ""}`} onMouseMove={e => this.dragLocation(e)} onMouseUp={() => this.setState({isSeeking: false})} onMouseLeave={() => this.setState({isSeeking: false})}>
	
							<div className="info-section" onMouseMove={e => this.dragLocation(e)} onMouseUp={() => this.setState({isSeeking: false})} onMouseLeave={() => this.setState({isSeeking: false})}>
								<p className="title">{activeVideo.content.title}</p>            
								<div className="buttons">
									<span className={`captions appletv-player-button ${this.state.openPopUp == "captions" ? "selected" : ""}`} >
										<img src={captions} onClick={this.toggleCaptionsSelection} />
										{this.state.openPopUp == "captions" && (
											selectionPopUp("captions")
										)}
									</span>                                     
									<span className={`audio-track appletv-player-button ${this.state.openPopUp == "audioTrack" ? "selected" : ""}`} >
										<img src={audio_track} onClick={this.toggleAudioTrackSelection} />
										{this.state.openPopUp == "audioTrack" && (
											selectionPopUp("audioTrack")
										)}
									</span>                                     
									<span className="fullscreen appletv-player-button" onClick={triggerFullscreen}>
										<img src={isFullscreen ? minimizeImg : expandImg} />
									</span>                                     
								</div>
							</div>

							<div className={"pilotly-button pilotly-bar-button pilotly-bar-button-seek"}>
								<div className="seek-control-container" onMouseMove={(e) => this.hoverTimestampLocation(e)}>
									<div className={`timestamp-preview ${isSeeking ? "display" : ""}`} style={{left: hoverProgressPercentageString}}>
										<img src={thumbnailURL} />
									</div>
									<div className="seek-bar" id="seek-bar" onClick={(e) => this.clickSeek(e)}></div>
									<div className="seek-bar-progress" style={{width: progressPercentageString}} ></div>
									<div className={`seek-bar-handle ${(skipButtonInfo && skipButtonInfo.target_promo_seek_enabled) || !isTargetAsset || isTester ? "" : "disabled"}`} onMouseDown={() => this.setState({isSeeking: true})} style={{left: progressPercentageString}}></div>
								</div>
							</div>

							<div className="timestamps">
								<div className="seek-bar-timestamp current-timestamp">
									{currentLocationString}
								</div>
								<div className="seek-bar-timestamp total-timestamp">
									{totalTimeStr}
								</div>
							</div>

							<div className="watch-page-buttons">
								{volumeControl}
								<span className="video-controls appletv-player-button" onClick={isPlaying ? pause : play}>
									<img src={isPlaying ? PauseImg : PlayImg} />
								</span>
								<div className="info-button" onClick={this.props.toggleInfoPanel}>{this.props.intl.formatMessage(svodMessages.info)}</div>
							</div>
						</div>
					);
				}
			}
		}
	}
}


const mapStateToProps = (state, ownProps) => ({
	volume: state.SVOD.volume, 
	environment: state.SVOD.environment,
	skipButtonInfo: state.targetProcess.fetchedGroup.svod_env.skip_button,
});

const mapDispatchToProps = (dispatch, ownProps) => ({
});

export default connect(mapStateToProps, mapDispatchToProps)(injectIntl(PlayerControls));


// WEBPACK FOOTER //
// ./src/components/svod/player-controls.jsx